import React from 'react';
import notFound from "./404.jpg";
function NotFound() {
    return (<img src={notFound} width="512px" alt="404"/>);

}

export default NotFound;